import theme from '../../theme/theme';

const {
  colors: { black_text, divider },
} = theme;

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    borderRadius: '0',
    minHeight: '4.625em',
    borderTop: `0.063em solid ${divider}`,
  },

  route__text: {
    textTransform: 'capitalize',
    fontSize: '1.8em',
    color: black_text,
    fontFamily: 'semibold',
    letterSpacing: '-0.031em',
  },
};

export default styles;
